import {animateInViewport} from "../transition";

$( '.media-carousel' ).each( function() {
	const swiper = new Swiper( this, {
		grabCursor: true,
		slidesPerView: 1,
		spaceBetween: 1,
		effect: 'fade',
		loop: true,
		autoplay: {
			delay: 1000,
			disableOnInteraction: true,
		},
		speed: 300,
	} );
} );

// $( '.media-carousel' ).each( function() {
// 	const $this = $( this );
//
// 	let autoplay = false;
// 	// if ( $this.data( 'autoplay' ) ) {
// 	autoplay = {
// 		delay: 2500,
// 	};
// 	// }
//
// 	const swiper = new Swiper( this, {
// 		pagination: {
// 			el: $this.find( '.swiper-pagination' )[ 0 ],
// 			clickable: true,
// 		},
// 		navigation: {
// 			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
// 			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
// 		},
// 		grabCursor: true,
// 		slidesPerView: 1,
// 		spaceBetween: 0,
// 		loop: true,
// 		crossFade: true,
// 		effect: 'fade',
// 		autoplay: autoplay,
// 		speed: 1000,
// 		allowTouchMove: false,
// 		on: {
// 			slideChange: animateInViewport,
// 			slideChangeTransitionEnd: animateInViewport,
// 			afterInit: updateSlideScales,
// 			progress: updateSlideScales,
// 		},
// 	} );
//
// 	function updateSlideScales( swiper ) {
// 		const scales = [];
// 		for ( const slide of swiper.slides ) {
// 			let progress = Math.abs( slide.progress );
// 			if ( progress > 0.03 ) {
// 				progress = 0.03;
// 			}
// 			let scale = 1 + progress;
// 			scales.push( scale );
// 			slide.querySelector( ".slide-inner" ).style.transform = "scale(" + scale + ")";
// 		}
// 	}
// } );

